import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/url/dist/style.css";
import "@uppy/webcam/dist/style.css";
import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import AwsS3 from "@uppy/aws-s3";

//import ImageCompressor from "./compressor"; //"uppy-plugin-image-compressor";
//const ImageCompressor = require("uppy-plugin-image-compressor");

import "./fu.scss";
import m from "mithril";
// import DragDrop from '@uppy/drag-drop';
// const GoogleDrive = require('@uppy/google-drive')
// const Dropbox = require('@uppy/dropbox')
// const Instagram = require('@uppy/instagram')
import Webcam from "@uppy/webcam";
// import Url from '@uppy/url';
// import Tus from '@uppy/tus';
import pf from "../pf";

import workermanager from "../worker-manager";
import fileutility from "../fileutility";
import {key, keys} from "localforage";
import {ulid} from "ulid";

export default () => {
	let id = null;
	let uppy = null;

	function ConditionalUseWebcam(plugin, options) {
		return use(plugin, options);
	}

	return {
		oncreate: (v) => {
			// console.log("allowed filetypes", v.attrs.filetypes);
			let newB64s = [];
			uppy = new Uppy({
				id: `$uppy${v.attrs.nf}`,
				debug: false,
				autoProceed: false,
				allowMultipleUploads: false,
				restrictions: {
					maxFileSize: 100000000,
					allowedFileTypes: (v.attrs.filetypes + "").split(" ").map((a) => `.${a}`), //['image/*'] //, 'video/*']
				},
				onBeforeUpload: (files, done) => {
					let keys = [];

					Promise.all(
						Object.keys(files).map((k) => {
							return new Promise((resolve) => {
								let f = files[k];
								keys.push({name: f.name, id: f.id, type: f.type});
								var reader = new FileReader();
								reader.readAsDataURL(f.data);
								reader.onloadend = function () {
									var base64data = reader.result;
									newB64s.push({
										caption: f.name,
										url: base64data,
										new: true,
										uuid: ulid(),
										nf: v.attrs.nf,
									});
									//workermanager.UpdateFile(v.attrs.nf, f.id, base64data);
									// console.log({newB64s});
									resolve();
								};
							});
						})
					).then((_) => {
						// workermanager.UpdateFiles(v.attrs.nf, keys, v.attrs.links, v.attrs.value, (r) => {
						// 	// onchange(r);
						// });

						workermanager.UploadFilesOffline(ulid(), v.attrs.nf, newB64s);

						// console.log("updaing entries", v.attrs.links, newB64s);

						if (v.attrs.links) newB64s = [...v.attrs.links, ...newB64s];
						// console.log("updated entries", {newB64s});
						if (v.attrs.onchange) v.attrs.onchange(newB64s);
					});

					// console.log({f: f.data});
					// let dataurl = fileutility.blobToDataURL(f.data);

					//to update the field and get links

					// 	console.log(v.attrs.links);
					// },
				},
			})
				.use(Dashboard, {
					trigger: `#fu${id}`,
					inline: false, //(!!v.attrs.inform),
					thumbnailWidth: 100,
					// width: 600,
					// height: 300,
					myDevice: "My Computer",
					target: "body",
					closeAfterFinish: false,
					hideUploadButton: false, //!!v.attrs.inform,
					showProgressDetails: true,
					note: `Up to 20 MB. Accept files of type ${v.attrs.filetypes}`,
					// height: "30vh",
					browserBackButtonClose: true,
				})
				.use(Webcam, {
					// target: Dashboard,
					// onBeforeSnapshot: () => Promise.resolve(),
					// countdown: false,
					// modes: ["picture"],
					// mirror: true,
					// // videoConstraints: {
					// //     facingMode: "environment",
					// //     width: { min: 720, ideal: 1280, max: 1920 },
					// //     height: { min: 480, ideal: 800, max: 1080 },
					// // },
					// showRecordingLength: false,
					// locale: {},
				});
			// .use(ImageCompressor, {
			//     // Options from Compressor.js https://github.com/fengyuanchen/compressorjs#options, just don’t set `success` or `error`
			//     // checkOrientation: true,
			//     quality: 0.9,
			//     maxWidth: 1280,
			//     maxHeight: 1280,
			// })
			// .use(AwsS3, {
			// 	getUploadParameters(file) {
			// 		// console.log("file", file);
			// 		return GetData("GetPresignedFileUploadRequest", {
			// 			filename: file.name,
			// 			contentType: file.type,
			// 			nf: v.attrs.nf,
			// 		}).then((r) => {
			// 			// console.log("received", r);
			// 			let returnObj = {
			// 				method: "PUT",
			// 				url: r.uploadurl,
			// 				fields: [],
			// 				headers: {
			// 					"x-amz-acl": "public-read",
			// 				},
			// 			};
			// 			// console.log("return object", returnObj);
			// 			return returnObj;
			// 		});
			// 	},
			// });

			if (v.attrs.localfu) {
				// console.log("assigning uppy to localfu");
				v.attrs.localfu[v.attrs.fname] = uppy;
			}

			// uppy.on("upload", (data) => {
			// 	// data object consists of `id` with upload ID and `fileIDs` array
			// 	// with file IDs in current upload
			// 	// data: { id, fileIDs }
			// 	// console.log(`Starting upload ${data.id} for files ${data.fileIDs}`);
			// 	console.log(data);
			// 	uppy.close();
			// });

			uppy.on("complete", (result) => {
				uppy.destroy();
			});
		},
		view: () => {
			if (!id) id = pf.uuid();
			return m(
				"a.UppyModalOpenerBtn",
				{
					id: `fu${id}`,
				},
				"upload"
			);
		},
	};
};
